<template>
	<view class="box">
		<view class="list">
			<view class="list-item active">
				<view class="list-item-a">
					<u-icon name="checkmark" color="#004096" size="18"></u-icon>
				</view>
				<view class="list-item-b">
					中国工商银行大钟楼支行(8788)
				</view>
				<view class="list-item-c">修改</view>
			</view>
			<view class="list-item">
				<view class="list-item-a"></view>
				<view class="list-item-b">
					中国工商银行大钟楼支行(8788)
				</view>
				<view class="list-item-c">修改</view>
			</view>
		</view>
		<view style="width: 100%; height: calc(env(safe-area-inset-bottom) + 108rpx);"></view>
		<view class="button">添加提现银行</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.button {
			width: calc(100vw - 60rpx);
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			background: #004096;
			border-radius: 44rpx;
			font-weight: 600;
			font-size: 32rpx;
			color: #FFFFFF;
			position: fixed;
			left: 30rpx;
			bottom: calc(env(safe-area-inset-bottom) + 20rpx);
		}
		.list {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.active {
				.list-item-b {
					font-weight: 600 !important;
					font-size: 30rpx !important;
					color: #222222 !important;
				}
			}
			.list-item {
				width: 100%;
				height: 102rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1rpx solid #E5E5E5;
				&:last-child {
					border: none !important;
				}
				.list-item-a {
					flex-shrink: 0;
					width: 60rpx;
				}
				.list-item-b {
					flex: 1;
					font-weight: 400;
					font-size: 30rpx;
					color: #222222;
				}
				.list-item-c {
					font-weight: 400;
					font-size: 28rpx;
					color: #004096;
				}
			}
		}
	}
</style>